module.exports = __webpack_public_path__ + "media/images/medal_2-b62c6de0d9d50d1ccd3b7c0f03899d6e.svg";